/**
 * TrainingType Filters Component
 * Inline filter bar: filters stay visible and apply live (no popover).
 */
import React from 'react';
import { InlineFilterBar, InlineSelect } from '../../../components/common';
import { useFilterState } from '../../../hooks/useFilterState';
import { TrainingTypeStatus, TrainingTypeStatusLabels } from '../../../types/trainingType';

export interface TrainingTypeFiltersData {
  searchTerm: string;
  status: string;
}

interface Props {
  onFilter: (filters: TrainingTypeFiltersData) => void;
  loading?: boolean;
  total?: number;
}

const STATUS_OPTIONS = Object.values(TrainingTypeStatus).map((s) => ({
  value: s,
  label: TrainingTypeStatusLabels[s],
}));

const defaultValues: TrainingTypeFiltersData = {
  searchTerm: '',
  status: '',
};

export const TrainingTypeFiltersComponent: React.FC<Props> = ({
  onFilter,
  loading = false,
  total,
}) => {
  const { filters, setFilter, clearAll, activeChips } = useFilterState(defaultValues, {
    onFilter,
    applyOnMount: true,
    live: true,
    labels: {
      status: 'Status',
    },
    formatValue: {
      status: (v: string) => TrainingTypeStatusLabels[v as TrainingTypeStatus] ?? v,
    },
  });

  return (
    <InlineFilterBar
      searchPlaceholder="Buscar por nome, fundamentação legal..."
      searchValue={filters.searchTerm}
      onSearchChange={(v) => setFilter('searchTerm', v)}
      resultCount={total}
      resultNoun="tipos"
      chips={activeChips}
      onClearAll={clearAll}
      loading={loading}
    >
      <InlineSelect
        label="Status"
        value={filters.status}
        options={STATUS_OPTIONS}
        onChange={(v) => setFilter('status', v)}
        emptyLabel="Todos"
        minWidth={140}
      />
    </InlineFilterBar>
  );
};

export default TrainingTypeFiltersComponent;
